import { render } from "./ProsesKerjasama.vue?vue&type=template&id=fa6ad6bc"
import script from "./ProsesKerjasama.vue?vue&type=script&lang=js"
export * from "./ProsesKerjasama.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__